import Icon from 'veui/components/Icon'

Icon.register({
  theme: {
    paths: [
      {
        d: 'M715 426.35a211.3 211.3 0 00-11-19.41V128a32 32 0 00-32-32H96a32 32 0 00-32 32v480a32 32 0 0032 32h160c3.86 0 7.7-.7 11.31-2.06a232.72 232.72 0 0033.63 35C349 713.59 412.61 736 480 736c24.1.02 48.11-2.92 71.5-8.75a32 32 0 0019.74-47.37 54.14 54.14 0 0187.28-63.29 32 32 0 0052-5.51A195.59 195.59 0 00715 426.35zM128 160h512v181.36c-45.24-31.4-101.17-48.48-160-48.48-67.39 0-131 22.41-179.06 63.09-23.9 20.23-42.73 43.91-56 70.38A195.27 195.27 0 00234 576H128V160zm540.27 385.47A118.12 118.12 0 00501.19 671c-7.02.67-14.08 1-21.19 1-105.87 0-192-70.68-192-157.56s86.13-157.56 192-157.56 192 70.68 192 157.56a130.2 130.2 0 01-3.73 31.03zM448 448a32 32 0 11-64 0 32 32 0 0164 0zm0 96a32 32 0 11-64 0 32 32 0 0164 0zm96-96a32 32 0 11-64 0 32 32 0 0164 0z'
      }
    ],
    width: '768',
    height: '768'
  }
})
